'use strict';
var $ = require('../internals/export');
var union = require('../internals/set-union');
var setMethodAcceptSetLike = require('../internals/set-method-accept-set-like');

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('union') }, {
  union: union
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.set.union.v2.js
// module id = 380
// module chunks = 0